/**
 * User-Agent Client Hints Detector
 */

export interface UserAgentHintsResult {
  brands?: Array<{ brand: string; version: string }>;
  mobile?: boolean;
  platform?: string;
  architecture?: string;
  bitness?: string;
  model?: string;
}

interface NavigatorUAData {
  brands: Array<{ brand: string; version: string }>;
  mobile: boolean;
  platform: string;
  getHighEntropyValues(hints: string[]): Promise<{
    architecture?: string;
    bitness?: string;
    model?: string;
    platform?: string;
    platformVersion?: string;
    uaFullVersion?: string;
  }>;
}

export async function detectUserAgentHints(): Promise<UserAgentHintsResult> {
  try {
    const uaData = (navigator as Navigator & { userAgentData?: NavigatorUAData }).userAgentData;

    if (!uaData) {
      return {};
    }

    const highEntropy = await uaData.getHighEntropyValues([
      'architecture',
      'bitness',
      'model',
      'platform',
    ]);

    return {
      brands: uaData.brands,
      mobile: uaData.mobile,
      platform: uaData.platform,
      architecture: highEntropy.architecture,
      bitness: highEntropy.bitness,
      model: highEntropy.model,
    };
  } catch (error) {
    return {};
  }
}
